import React, { useContext } from 'react';

import { Invites } from '@vyce/core/src/modules';
import { WidgetWrapper, WidgetWrapperProps } from '@vyce/core/src/components/Dashboard/WidgetWrapper';

import { useTypedSelector } from 'src/hooks';
import { InvitesContext } from 'src/store/invites-context';

export const InviteListWidget = (props: WidgetWrapperProps) => {
  const { selectedCompany } = useTypedSelector(state => state.helper);
  const { getInvites, resendInvite, deleteInvite, retryInviteItem } = useContext(InvitesContext);

  return (
    <WidgetWrapper {...props}>
      <Invites
        selectedCompanyId={selectedCompany?.uuid}
        deleteInviteRequest={deleteInvite}
        getInvitesRequest={getInvites}
        resendInviteRequest={resendInvite}
        retryInviteItemRequest={retryInviteItem}
        inviteButton={() => <></>}
        hideFilters
        height="calc(100% - 40px)"
      />
    </WidgetWrapper>
  );
};
